export default "__VITE_ASSET__06a6599e__"